import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/zakaznici-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.nazev(),
    COLUMNS_AVAILABLE.ico(),
    COLUMNS_AVAILABLE.adresa()
  ];
  return useMemo(() => [columns], []);
}
